var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "dragDiv", staticClass: "drag" }, [
    _c("div", { staticClass: "drag_bg" }),
    _c("div", { staticClass: "drag_text" }, [_vm._v(_vm._s(_vm.confirmWords))]),
    _c("div", {
      ref: "moveDiv",
      staticClass: "handler handler_bg",
      class: { handler_ok_bg: _vm.confirmSuccess },
      staticStyle: { position: "absolute", top: "0px", left: "0px" },
      on: {
        mousedown: function($event) {
          return _vm.mousedownFn($event)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-297ca37c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297ca37c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/common/ValidateCode.vue
// module id = nO3g
// module chunks = 0 1 2 3